export default "__VITE_ASSET__DZUDt9n2__"